var typography = {
  button: {
    fontSize: 13,
    fontWeight: "medium",
    lineHeightSpace: 2,
    letterSpacing: 0.7,
    isUppercase: true
  },
  buttonBig: {
    fontSize: 16,
    fontWeight: "medium",
    lineHeightSpace: 2.5,
    letterSpacing: 0.7,
    isUppercase: true
  },
  buttonSmall: {
    fontSize: 11,
    fontWeight: "medium",
    lineHeightSpace: 1.5,
    letterSpacing: 0.7,
    isUppercase: true
  },
  giant: {
    fontSize: 48,
    fontWeight: "light",
    lineHeightSpace: 8,
    mobile: {
      fontSize: 34,
      lineHeightSpace: 5.5
    }
  },
  sgiant: {
    fontSize: 44,
    fontWeight: "light",
    lineHeightSpace: 7,
    mobile: {
      fontSize: 44,
      lineHeightSpace: 6.5
    }
  },
  sgiant_2: {
    fontSize: 44,
    fontWeight: "normal",
    lineHeightSpace: 7,
    mobile: {
      fontSize: 44,
      lineHeightSpace: 6.5
    }
  },
  lgiant: {
    fontSize: 44,
    fontWeight: "medium",
    lineHeightSpace: 7,
    letterSpacing: -1,
    mobile: {
      fontSize: 44,
      lineHeightSpace: 6.5
    }
  },
  giant2: {
    fontSize: 48,
    fontWeight: "medium",
    lineHeightSpace: 8,
    mobile: {
      fontSize: 34,
      lineHeightSpace: 5.5
    }
  },
  xhuge: {
    fontSize: 40,
    fontWeight: "normal",
    lineHeightSpace: 6.5,
    mobile: {
      fontSize: 28,
      lineHeightSpace: 4.5
    }
  },
  huge: {
    fontSize: 36,
    fontWeight: "medium",
    lineHeightSpace: 6,
    mobile: {
      fontSize: 28,
      lineHeightSpace: 4.5
    }
  },
  great: {
    fontSize: 32,
    fontWeight: "medium",
    lineHeightSpace: 5.5,
    mobile: {
      fontSize: 24,
      lineHeightSpace: 4
    }
  },
  xlarge: {
    fontSize: 28,
    fontWeight: "medium",
    lineHeightSpace: 4.5,
    mobile: {
      fontSize: 22,
      lineHeightSpace: 3.5
    }
  },
  large1: {
    fontSize: 24,
    fontWeight: "light",
    lineHeightSpace: 4,
    boldTypography: "large3",
    mobile: {
      fontSize: 20,
      lineHeightSpace: 3.5
    }
  },
  large2: {
    fontSize: 24,
    fontWeight: "normal",
    lineHeightSpace: 4,
    boldTypography: "large3",
    mobile: {
      fontSize: 20,
      lineHeightSpace: 3.5
    }
  },
  large3: {
    fontSize: 24,
    fontWeight: "medium",
    lineHeightSpace: 4,
    boldTypography: "large3",
    mobile: {
      fontSize: 20,
      lineHeightSpace: 3.5
    }
  },
  big1: {
    fontSize: 18,
    fontWeight: "light",
    lineHeightSpace: 3,
    boldTypography: "big3"
  },
  big2: {
    fontSize: 18,
    fontWeight: "normal",
    lineHeightSpace: 3,
    boldTypography: "big4"
  },
  big3: {
    fontSize: 18,
    fontWeight: "medium",
    boldTypography: "big4",
    lineHeightSpace: 3
  },
  big4: {
    fontSize: 18,
    fontWeight: "bold",
    boldTypography: "big4",
    lineHeightSpace: 3
  },
  medium1_s: {
    fontSize: 16,
    fontWeight: "light",
    lineHeightSpace: 2.5,
    boldTypography: "medium3_s"
  },
  medium2_s: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeightSpace: 2.5,
    boldTypography: "medium4_s"
  },
  medium3_s: {
    fontSize: 16,
    fontWeight: "medium",
    boldTypography: "medium4_s",
    lineHeightSpace: 2.5
  },
  medium4_s: {
    fontSize: 16,
    fontWeight: "bold",
    boldTypography: "medium4_s",
    lineHeightSpace: 2.5
  },
  medium1_h: {
    fontSize: 16,
    fontWeight: "light",
    lineHeightSpace: 3,
    boldTypography: "medium3_h"
  },
  medium2_h: {
    fontSize: 16,
    fontWeight: "normal",
    lineHeightSpace: 3,
    boldTypography: "medium4_h"
  },
  medium3_h: {
    fontSize: 16,
    fontWeight: "medium",
    boldTypography: "medium4_h",
    lineHeightSpace: 3
  },
  medium4_h: {
    fontSize: 16,
    fontWeight: "bold",
    boldTypography: "medium4_h",
    lineHeightSpace: 3
  },
  small1: {
    fontSize: 14,
    fontWeight: "light",
    lineHeightSpace: 2.5,
    boldTypography: "small3"
  },
  small2: {
    fontSize: 14,
    fontWeight: "normal",
    lineHeightSpace: 2.5,
    boldTypography: "small4"
  },
  small3: {
    fontSize: 14,
    fontWeight: "medium",
    boldTypography: "small4",
    lineHeightSpace: 2.5
  },
  small4: {
    fontSize: 14,
    fontWeight: "bold",
    boldTypography: "small4",
    lineHeightSpace: 2.5
  },
  small4_u: {
    fontSize: 14,
    fontWeight: "bold",
    lineHeightSpace: 2.5,
    boldTypography: "small4",
    isUppercase: true
  },
  xsmall1: {
    fontSize: 13,
    fontWeight: "normal",
    lineHeightSpace: 2,
    boldTypography: "xsmall3"
  },
  xsmall1_h: {
    fontSize: 13,
    fontWeight: "normal",
    lineHeightSpace: 3,
    boldTypography: "xsmall3"
  },
  xsmall2: {
    fontSize: 13,
    fontWeight: "medium",
    lineHeightSpace: 2,
    boldTypography: "xsmall3"
  },
  xsmall2_u: {
    fontSize: 13,
    fontWeight: "medium",
    lineHeightSpace: 2,
    isUppercase: true,
    boldTypography: "xsmall3"
  },
  xsmall3: {
    fontSize: 13,
    fontWeight: "bold",
    lineHeightSpace: 2,
    boldTypography: "xsmall3"
  },
  tiny1: {
    fontSize: 12,
    fontWeight: "normal",
    lineHeightSpace: 2,
    boldTypography: "tiny3"
  },
  tiny1_u: {
    fontSize: 12,
    fontWeight: "normal",
    lineHeightSpace: 2,
    isUppercase: true,
    boldTypography: "tiny3"
  },
  tiny2: {
    fontSize: 12,
    fontWeight: "medium",
    lineHeightSpace: 2,
    boldTypography: "tiny3"
  },
  tiny3: {
    fontSize: 12,
    fontWeight: "bold",
    lineHeightSpace: 2,
    boldTypography: "tiny3"
  },
  nano1: {
    fontSize: 11,
    fontWeight: "normal",
    lineHeightSpace: 2,
    boldTypography: "nano3"
  },
  nano2: {
    fontSize: 11,
    fontWeight: "medium",
    lineHeightSpace: 2,
    boldTypography: "nano3"
  },
  nano2_u: {
    fontSize: 11,
    fontWeight: "medium",
    lineHeightSpace: 2,
    isUppercase: true,
    boldTypography: "nano3"
  },
  nano3: {
    fontSize: 11,
    fontWeight: "bold",
    lineHeightSpace: 2,
    boldTypography: "nano3"
  }
};
export default typography;